import Aparecer from './Aparecer';
import type { OndeEsta } from '@/pages/gerenciar/painel/financeiro/relatorio/types';
import { formatarCentavos } from '@/pages/loja/utils';

// Card "Onde está o dinheiro": só as linhas com valor > 0.
export default function OndeEstaCartao({ o }: { o: OndeEsta }) {
  const linhas = [
    { rotulo: 'Conta Mercado Pago', valor: o.na_conta_mp, icone: 'ri-bank-card-line' },
    { rotulo: 'Já repassado', valor: o.repassado, icone: 'ri-send-plane-line' },
    { rotulo: 'Com o Se Liga', valor: o.com_seliga, icone: 'ri-safe-2-line' },
  ].filter((l) => l.valor > 0);

  if (linhas.length === 0) return null;

  return (
    <Aparecer>
      <section className="rel-secao rounded-2xl border border-background-200 bg-white p-4 shadow-[0_1px_3px_rgba(16,24,40,0.04)] md:p-5">
        <h2 className="text-[15px] font-bold text-foreground-950">Onde está o dinheiro</h2>
        <ul className="mt-2 divide-y divide-background-100">
          {linhas.map((l) => (
            <li key={l.rotulo} className="flex items-center justify-between gap-3 py-3">
              <span className="flex min-w-0 items-center gap-2.5 text-[14px] text-foreground-700">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                  <i className={`${l.icone} text-base`} />
                </span>
                <span className="truncate">{l.rotulo}</span>
              </span>
              <span className="shrink-0 text-[16px] font-extrabold tabular-nums text-foreground-950">
                {formatarCentavos(l.valor)}
              </span>
            </li>
          ))}
        </ul>
      </section>
    </Aparecer>
  );
}